import { sendEventToJumbo } from './jumbo';

export const VALET_EVENTS = {
  GET_VALET_DETAILS_SUCCESS: 'get_valet_details_success',
  GET_VALET_DETAILS_FAILURE: 'get_valet_details_failure',
  GET_VALET_NUMBER_SUCCESS: 'get_valet_number_success',
  GET_VALET_NUMBER_FAILURE: 'get_valet_number_failure',
  VALET_POLLING_START_EVENT: 'valet_polling_start_event',
  VALET_POLLING_STOP_EVENT: 'valet_polling_stop_event',
  VALET_CALL_LOGS_MODAL_OPEN: 'valet_call_logs_modal_open',
  VALET_ASSIGNMENT_HISTORY_MODAL_OPEN: 'valet_assignment_history_modal_open',
  VALET_MODAL_CLOSE: 'valet_modal_close',
};

export const sendValetApiEvents = (eventName, orderId, customerId) => {
  sendEventToJumbo({
    eventName,
    orderId,
    customerId,
  });
};

export const sendValetModalEvents = (eventName, orderId, customerId) => {
  sendEventToJumbo({
    eventName,
    orderId,
    customerId,
  });
};
